import Link from '@/lib/nav/link';
import { usePathname } from '@/lib/nav/navigation';
import {
  ROUNDED_SEGMENT_GROUP_CLASS,
  roundedSegmentItemClass,
} from '@/components/roam-app/rounded-segment-control';
import { cn } from '@/lib/utils';

const TABS = [
  { href: '/terms', label: 'Terms', match: (path: string) => path === '/terms' },
  {
    href: '/privacy',
    label: 'Privacy',
    match: (path: string) => path === '/privacy',
  },
  {
    href: '/privacy/health-notice',
    label: 'Health',
    match: (path: string) => path.startsWith('/privacy/health-notice'),
  },
  {
    href: '/legal/how-we-make-money',
    label: 'Money',
    match: (path: string) => path.startsWith('/legal/how-we-make-money'),
  },
] as const;

export function LegalNavTabs({ className }: { className?: string }) {
  const pathname = usePathname();

  return (
    <nav
      className={cn(
        ROUNDED_SEGMENT_GROUP_CLASS,
        'grid-cols-4 text-[11px] sm:text-[13px]',
        className,
      )}
      aria-label="Legal documents"
    >
      {TABS.map((tab) => (
        <Link
          key={tab.href}
          href={tab.href}
          className={roundedSegmentItemClass(tab.match(pathname), 'px-1.5 sm:px-2')}
        >
          {tab.label}
        </Link>
      ))}
    </nav>
  );
}
